var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"pais","rota-base":"/admin/pais","titulo-singular":"País","campos-extras":[
        { campo: "nacionalidade", label: "Nacionalidade", span: 12 },
        { campo: "ddi", label: "DDI", span: 6 },
        { campo: "cod_censo", label: "Código Censo (INEP)", span: 6 }
    ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }